import { CameraIntrinsics } from './CameraIntrinsics';
export class AreaScanDivision extends CameraIntrinsics {
    focalLength;
    imageCenterX;
    imageCenterY;
    imageHeight;
    imageWidth;
    kappa;
    pixelScaleX;
    pixelScaleY;
    constructor(params) {
        super();
        this.focalLength = params.focalLength;
        this.imageCenterX = params.imageCenterX;
        this.imageCenterY = params.imageCenterY;
        this.imageHeight = params.imageHeight;
        this.imageWidth = params.imageWidth;
        this.kappa = params.kappa;
        this.pixelScaleX = params.pixelScaleX;
        this.pixelScaleY = params.pixelScaleY;
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQXJlYVNjYW5EaXZpc2lvbi5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9saWIvdHlwZXMvY2FtZXJhL0FyZWFTY2FuRGl2aXNpb24udHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sb0JBQW9CLENBQUE7QUFhckQsTUFBTSxPQUFPLGdCQUFpQixTQUFRLGdCQUFnQjtJQUNwRCxXQUFXLENBQVE7SUFDbkIsWUFBWSxDQUFRO0lBQ3BCLFlBQVksQ0FBUTtJQUNwQixXQUFXLENBQVE7SUFDbkIsVUFBVSxDQUFRO0lBQ2xCLEtBQUssQ0FBUTtJQUNiLFdBQVcsQ0FBUTtJQUNuQixXQUFXLENBQVE7SUFFbkIsWUFBWSxNQUE4QjtRQUN4QyxLQUFLLEVBQUUsQ0FBQTtRQUNQLElBQUksQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FBQTtRQUNyQyxJQUFJLENBQUMsWUFBWSxHQUFHLE1BQU0sQ0FBQyxZQUFZLENBQUE7UUFDdkMsSUFBSSxDQUFDLFlBQVksR0FBRyxNQUFNLENBQUMsWUFBWSxDQUFBO1FBQ3ZDLElBQUksQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FBQTtRQUNyQyxJQUFJLENBQUMsVUFBVSxHQUFHLE1BQU0sQ0FBQyxVQUFVLENBQUE7UUFDbkMsSUFBSSxDQUFDLEtBQUssR0FBRyxNQUFNLENBQUMsS0FBSyxDQUFBO1FBQ3pCLElBQUksQ0FBQyxXQUFXLEdBQUcsTUFBTSxDQUFDLFdBQVcsQ0FBQTtRQUNyQyxJQUFJLENBQUMsV0FBVyxHQUFHLE1BQU0sQ0FBQyxXQUFXLENBQUE7SUFDdkMsQ0FBQztDQUNGIn0=